// Scope a resource list to what the current role may see in the workspace
// switcher. The `/user/resource` endpoint is the public markets directory and
// returns every resource, so the client must scope it for market owners.
//
// - Superusers/admins: all resources (they operate across every workspace).
// - Forecasters: all resources (they browse open markets to submit forecasts).
// - Market owners / viewers: only resources they own or manage.

export const getManagedResourceIdSet = (managedResources) =>
  new Set((managedResources || []).map((r) => r.resourceId).filter(Boolean));

// Market owners (non-admin, non-forecaster) are the only role scoped down.
export const shouldScopeToManaged = ({ isAdmin, isForecaster }) =>
  !isAdmin && !isForecaster;

export const scopeResourcesToRole = (
  resources,
  { managedResources, isAdmin, isForecaster } = {}
) => {
  if (!Array.isArray(resources)) return [];
  if (!shouldScopeToManaged({ isAdmin, isForecaster })) return resources;
  const managedIds = getManagedResourceIdSet(managedResources);
  return resources.filter((r) => managedIds.has(r.id));
};
